import Component from '@glimmer/component';
import { service } from '@ember/service';
import { SystemNotifications, Notifications } from 'core/components';
import HcpMarketing from 'hcp/components/hcp-marketing';
import Main from 'hcp/components/page/sign-in/main';

/**
 *
 * `PageSignIn` renders a page which redirects you to the auth provider.
 *
 *
 * ```
 * <Page::SignIn />
 * ```
 *
 * @class PageSignIn
 *
 */
/**
 *
 * `error` will be a sign in error.
 * @argument error;
 * @type {String}
 *
 */
export default class PageSignIn extends Component {
  @service config;
  @service systemStatus;

  get authenticatorType() {
    return this.config.authenticatorType;
  }

  get statusPageUrl() {
    return this.systemStatus.statusPageUrl;
  }
  <template>
    <SystemNotifications />
    <Notifications />
    <HcpMarketing data-test-page-sign-in ...attributes as |M|>
      <M.Main>
        <Main
          @connection={{@connection}}
          @error={{@error}}
          @isSignUpPage={{false}}
        />
      </M.Main>
      <M.Aside />
    </HcpMarketing>
  </template>
}
